import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import AppHeader from '@/components/common/AppHeader'
import AppFooter from '@/components/common/AppFooter'

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition">
      <AppHeader />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-8"
        >
          <div className="mb-4">
            <Link to="/login" className="text-sm text-gray-600 hover:text-gray-900">
              ← Back to Login
            </Link>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy & Terms of Service</h1>

          <div className="prose max-w-none space-y-6 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">Terms of Service</h2>
              <p className="mb-4">
                By using Catechism Cloud, you agree to the following terms:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>These Terms of Service are governed by Wyoming (WY) law.</li>
                <li>Any disputes will be resolved through binding arbitration as specified in Wyoming law.</li>
                <li>Catechism Cloud software is not responsible for managing activity, messages, users, parents, or any content posted by users.</li>
                <li>In the event of a user dispute, the vendor will regard the Primary Administrator as the rightful subscription license holder.</li>
                <li>Absent exigent circumstances or direction by a legal authority, Catechism Cloud regards the Primary Administrator as the authorized account holder.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">Privacy Policy</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Data Use & Storage</h3>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Catechism Cloud may read or save messages or data as necessary for the site to function.</li>
                <li>When data is deleted, it may be retained for up to 90 days for recovery purposes.</li>
                <li>After 90 days, deleted data will be permanently removed from our systems.</li>
                <li>Catechism Cloud will not sell or share your data with third parties without permission, except as necessary to make the site function (e.g., payment processing, email services).</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">No Expectation of Privacy</h3>
              <p className="mb-4">
                By using Catechism Cloud, you acknowledge that:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>You have no expectation of privacy for data stored on or transmitted through Catechism Cloud.</li>
                <li>Catechism Cloud administrators may access your data as necessary for technical support, account management, or legal compliance.</li>
                <li>Messages sent through the platform may be monitored or reviewed for technical or security purposes.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Account Responsibility</h3>
              <p className="mb-4">
                You are responsible for:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Maintaining the confidentiality of your account credentials.</li>
                <li>All activities that occur under your account.</li>
                <li>Ensuring that any data you provide is accurate and complies with applicable laws.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">Subscription & Account Holder</h2>
              <p className="mb-4">
                The Primary Administrator is the designated subscription license holder for each parish account. All billing, account management, and administrative decisions regarding the parish account are made by the Primary Administrator or their designated representatives.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">Changes to Terms</h2>
              <p className="mb-4">
                Catechism Cloud reserves the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section className="pt-4 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                Last updated: {new Date().toLocaleDateString()}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                For questions about this Privacy Policy or Terms of Service, please <Link to="/contact" className="text-yellow-600 hover:text-yellow-700">contact us</Link>.
              </p>
            </section>
          </div>
        </motion.div>
      </main>
      <AppFooter />
    </div>
  )
}

